<p class="welcome-to-warema-plus-label">
    {{ 'DASHBOARD_PUBLIC.WELCOME_TO_WAREMA_PLUS' | translate }}
</p>
<p class="sub-title-description-label">
    {{ 'DASHBOARD_PUBLIC.SUB_TITLE_DESCRIPTION' | translate }}
</p>

<div class="banner" [style.background-image]="'url(' + bannerUrl + ')'">
    <div class="banner-items">
        @for (item of bannerItems; track item) {
            <div class="item">
                <div class="item-icon">
                    <warema-svg-icon
                        aria-hidden="true"
                        [filePath]="'assets/images/' + item.iconPath + '.svg'"
                        [height]="item.iconHeight"
                        [width]="item.iconWidth"
                    />
                </div>
                <div class="item-content">
                    <div class="item-title">{{ item.title | translate }}</div>
                    <div class="item-text">{{ item.text | translate }}</div>
                </div>
            </div>
        }
    </div>

    <div class="buttons-instructions-wrapper">
        <div class="action-buttons">
            <warema-button
                class="register-btn"
                id="register-btn"
                size="large"
                [text]="'CREATE_AN_ACCOUNT' | translate"
                (click)="register()"
            />

            <warema-button
                class="already-have-account-btn"
                id="already-have-account-btn"
                size="large"
                type="secondary"
                [text]="'I_ALREADY_HAVE_AN_ACCOUNT' | translate"
                (click)="login()"
            />
        </div>

        <div class="instructions">
            <div class="do-you-need-help">{{ 'DO_YOU_NEED_HELP' | translate }}</div>
            <div class="instruction registration" (click)="openRegistrationInstructions()">
                <warema-svg-icon
                    aria-hidden="true"
                    filePath="assets/images/icons/play-icon_small.svg"
                    height="20"
                    width="20"
                />
                {{ 'HOW_DOES_THE_REGISTRATION_WORK' | translate }}
            </div>
            <div class="instruction" (click)="openPasswordResetInstructions()">
                <warema-svg-icon filePath="assets/images/icons/play-icon_small.svg" height="20" width="20" />
                {{ 'HOW_TO_RESET_PASSWORD' | translate }}
            </div>
        </div>
    </div>
</div>

<p class="only-three-steps">
    {{ 'DASHBOARD_PUBLIC.ONLY_THREE_STEPS_TO_YOUR_WAREMA_PLUS_ACCESS' | translate }}
</p>

<div class="access-steps">
    @for (accessStep of waremaPlusAccessSteps; track accessStep) {
        <div class="access-step">
            <div class="access-step-icon">
                <warema-svg-icon
                    aria-hidden="true"
                    [filePath]="'assets/images/' + accessStep.iconPath + '.svg'"
                    [height]="accessStep.iconHeight"
                    [width]="accessStep.iconWidth"
                />
            </div>
            <div class="access-step-number">{{ accessStep.number }}</div>
            <div class="access-step-description">
                {{ accessStep.text | translate }}
            </div>
        </div>
    }
</div>
